export default class ErrorException extends Error { }
